import axios from "./axiosInstance";

const contactFormAPI = {
  contact_form: (payload) => axios.post("contact-us", payload),
};

export default contactFormAPI;
